import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-governance',
  templateUrl: './governance.component.html',
  styleUrls: ['./governance.component.scss']
})
export class GovernanceComponent implements OnInit {

  fileList = [];

  constructor() { }

  ngOnInit(): void {

    this.fileList = [
      {
        fileName: "碩達系統股份有限公司反賄絡暨經營條款.pdf"
      },
      {
        fileName: "碩達系統股份有限公司行為準則.pdf"
      },
      {
        fileName: "碩達系統股份有限公司員工關懷政策.pdf"
      },
      {
        fileName: "碩達系統股份有限公司隱私保護政策.pdf"
      },
      {
        fileName: "供應商及客戶隱私權保護實行準則.pdf"
      }
    ];
  }

}
